import "modules/RecallsDashboard/components/RecallsLastExport/RecallsLastExport.scss";
import { useRecallsLastImport } from "modules/RecallsDashboard/service";
import { DATE_FORMATS_FNS, formatDate } from "util/dateHelpers";

export const RecallsLastExport = () => {
  const { data } = useRecallsLastImport();
  if (!data) return null;

  return (
    <div className="RecallsLastExport">
      <div className="title">Last imported: </div>
      <div className="date">{formatDate(data.last_imported, DATE_FORMATS_FNS.yearMonthDateDash)}</div>
    </div>
  );
};
